/** Espelha `HealthUnitType` e `HEALTH_UNIT_TYPE_RADIUS_PRESET_M` do backend (health-unit-type.ts). */
export enum HealthUnitType {
  UBS_PSF = 'UBS_PSF',
  HOSPITAL = 'HOSPITAL',
  UPA = 'UPA',
  SAMU_ITINERANT = 'SAMU_ITINERANT',
  CLINIC = 'CLINIC'
}

export const HEALTH_UNIT_TYPE_LABELS: Record<HealthUnitType, string> = {
  [HealthUnitType.UBS_PSF]: 'UBS / PSF',
  [HealthUnitType.HOSPITAL]: 'Hospital',
  [HealthUnitType.UPA]: 'UPA',
  [HealthUnitType.SAMU_ITINERANT]: 'SAMU / itinerante',
  [HealthUnitType.CLINIC]: 'Clínica'
}

export const HEALTH_UNIT_TYPE_OPTIONS = (
  Object.keys(HEALTH_UNIT_TYPE_LABELS) as HealthUnitType[]
).map((value) => ({
  title: HEALTH_UNIT_TYPE_LABELS[value],
  value
}))

export const RADIUS_PRESET_BY_TYPE: Record<HealthUnitType, number> = {
  [HealthUnitType.UBS_PSF]: 200,
  [HealthUnitType.CLINIC]: 150,
  [HealthUnitType.UPA]: 300,
  [HealthUnitType.HOSPITAL]: 300,
  [HealthUnitType.SAMU_ITINERANT]: 500
}

export const RADIUS_CHIPS = [150, 200, 300, 500] as const

export function radiusPresetFor(type: HealthUnitType | null | undefined): number {
  return RADIUS_PRESET_BY_TYPE[type ?? HealthUnitType.CLINIC]
}

export function unitTypeLabel(type: HealthUnitType | null | undefined): string {
  return type ? HEALTH_UNIT_TYPE_LABELS[type] : '—'
}
